import { Fragment, useLayoutEffect, useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTopoloWorkspaceResource } from '@topolo-io/app-shell';

export function WorkspaceRouteBoundary({ children }: { children: ReactNode }) {
  const { currentWorkspaceId } = useTopoloWorkspaceResource();
  const navigate = useNavigate();
  const [renderedWorkspaceId, setRenderedWorkspaceId] = useState(currentWorkspaceId);

  useLayoutEffect(() => {
    if (renderedWorkspaceId !== currentWorkspaceId) {
      navigate('/projects', { replace: true });
      setRenderedWorkspaceId(currentWorkspaceId);
    }
  }, [currentWorkspaceId, renderedWorkspaceId, navigate]);

  if (renderedWorkspaceId !== currentWorkspaceId) return null;
  return <Fragment key={currentWorkspaceId}>{children}</Fragment>;
}
